import { useParams } from "react-router-dom";
import { useGetOne, usePermissions } from "react-admin";
import {
  TextField as MuiTextField,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";

const FormPreview = () => {
  // ✅ ALWAYS CALL HOOKS FIRST
  const { permissions = [] } = usePermissions();
  const { id } = useParams();
  const { data, isLoading } = useGetOne("forms", { id });

  // ✅ Permission Check AFTER hooks
  const canView =
    permissions.includes("forms.read") ||
    permissions.includes("forms.*") ||
    permissions.includes("*");

  if (!canView) {
    return <p>Not authorized</p>;   // or return null;
  }

  if (isLoading) return <p>Loading...</p>;

  return (
    <div style={{ padding: 24, maxWidth: 800 }}>
      <h2>{data.title}</h2>

      {data.form_json.map((q, index) => (
        <div key={q.id} style={{ marginBottom: 24 }}>
          <strong>
            {index + 1}. {q.is_required && " *"} {q.question_text}
          </strong>

          {q.add_to_table && <strong> (Added in Table)</strong>}

          {q.field_type === "text" && (
            <MuiTextField fullWidth disabled placeholder="User input" sx={{ mt: 1 }} />
          )}

          {q.field_type === "radio" && (
            <RadioGroup>
              {q.options?.map((opt) => (
                <FormControlLabel
                  key={opt}
                  value={opt}
                  control={<Radio disabled />}
                  label={opt}
                />
              ))}
            </RadioGroup>
          )}

          {q.field_type === "checkbox" &&
            q.options?.map((opt) => (
              <FormControlLabel
                key={opt}
                control={<Checkbox disabled />}
                label={opt}
              />
            ))}
        </div>
      ))}
    </div>
  );
};

export default FormPreview;